import React, { CSSProperties } from 'react';

type Props = CSSProperties & {
    children?: React.ReactNode;
    className?: string;
};

const FlexBox: React.FC<Props> = ({ children, className, ...style }) => (
    <div className={className} style={{ display: 'flex', ...style }}>
        {children}
    </div>
);

export default FlexBox;
